import { render, staticRenderFns } from "./freeExitRecordList.vue?vue&type=template&id=a06ad882&scoped=true&"
import script from "./freeExitRecordList.vue?vue&type=script&lang=js&"
export * from "./freeExitRecordList.vue?vue&type=script&lang=js&"
import style0 from "./freeExitRecordList.vue?vue&type=style&index=0&id=a06ad882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06ad882",
  null
  
)

export default component.exports